import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'
import { withRouter } from 'react-router'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment'
import Close from '@material-ui/icons/Close'
import ZoomIn from '@material-ui/icons/ZoomIn'
// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'

import { deleteRecord } from '../../services/generalServiceAPI'

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'
import { reactTableFilterCaseInsensitive } from '../utility/utility'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
}

class UsersAllTable extends React.Component {
  render() {
    const { classes, users } = this.props
    const data = users.map((prop, key) => {
      return {
        ...prop,
        actions: (
          <div className="actions-right">
            <Button
              justIcon
              round
              simple
              onClick={() => {
                // let obj = this.state.data.find(o => o._id === prop._id)
                // don't have history available in props with withRouter higher order component
                // state for history.push has 640k limitation, actions added in this row data inflate the size of the object
                console.log(prop)
                this.props.history.push({
                  pathname: '/administration/updateuser',
                  state: { ...prop }
                })
              }}
              color="info"
              className="like"
            >
              <ZoomIn />
            </Button>{' '}
            <Button
              justIcon
              round
              simple
              onClick={async () => {
                await deleteRecord({
                  tableName: 'users',
                  id: prop.id,
                  refetch: this.props.refetch
                })
              }}
              color="danger"
              className="remove"
            >
              <Close />
            </Button>{' '}
          </div>
        )
      }
    })
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Users</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={data}
                filterable
                defaultFilterMethod={(filter, row) => reactTableFilterCaseInsensitive(filter, row)}
                columns={[
                  {
                    Header: 'Username',
                    accessor: 'username'
                  },
                  {
                    Header: 'Name',
                    id: 'name',
                    accessor: r => r.firstname + ' ' + r.lastname
                  },
                  {
                    Header: 'Company',
                    accessor: 'company.name'
                  },
                  {
                    Header: 'Department',
                    accessor: 'department.name'
                  },
                  {
                    Header: 'Poisition',
                    accessor: 'position.name'
                  },
                  {
                    Header: 'Manager',
                    id: 'manager',
                    accessor: r => (r.reportTo ? r.reportTo.name : '')
                  },
                  {
                    Header: 'Weight',
                    id: 'weight',
                    accessor: 'weight'
                  },
                  {
                    Header: () => <div style={{ textAlign: 'left' }}>Actions</div>,
                    accessor: 'actions',
                    filterable: false,
                    sortable: false
                  }
                ]}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom //={true} //can be ignored
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}

const ust = withStyles(styles)(UsersAllTable)
export default withRouter(ust)
